import { render, staticRenderFns } from "./documentDetailModal.vue?vue&type=template&id=0cd43c40&scoped=true&"
import script from "./documentDetailModal.vue?vue&type=script&lang=js&"
export * from "./documentDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./documentDetailModal.vue?vue&type=style&index=0&id=0cd43c40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd43c40",
  null
  
)

export default component.exports